if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const mediaId = this.openedBy.getAttribute('data-media-id');
        if (!mediaId) return; // Exit if no data-media-id

        // Deactivate all media except the active one
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${mediaId}"])`)
          .forEach((element) => element.classList.remove('active'));

        const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeMedia) return; // Exit if no matching media found

        activeMedia.classList.add('active');
        activeMedia.scrollIntoView({ behavior: 'smooth', block: 'center' });

        const container = this.querySelector('[role="document"]');
        if (activeMedia.width && container.clientWidth) {
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        }

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        if (
          activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }
    }
  );
}
